export const CHAMELEON_CACHE_v1 = 'chameleon-cache-v1';

export const getCache = async () => {
  let $;
  // return caches.open(CHAMELEON_CACHE_v1);
  try {
    // throw 'ERRORz';

    $ = caches.open(CHAMELEON_CACHE_v1);
  } catch (err) {
    $ = {
      match() {
        return Promise.resolve(undefined);
      },
      add() {
        return Promise.resolve(undefined);
      },
      put() {
        return undefined;
      },
      delete() {
        return undefined;
      },
    };
  }

  return $;
};
